import React from 'react';
import PropTypes from 'prop-types';

import styles from './ExternalLink.module.scss';

const ExternalLink = ({
  href,
  content = '',
  children,
  notBlank,
}) => (
  <a
    className={styles.main}
    href={href}
    target={notBlank ? '_self' : '_blank'}
    rel="noopener noreferrer"
  >
    {content || children}
  </a>
);

ExternalLink.propTypes = {
  content: PropTypes.string,
  children: PropTypes.node,
  href: PropTypes.string.isRequired,
  notBlank: PropTypes.bool,
};

export default ExternalLink;
